export default {
  setTasks: (state, tasks) => {
    state.tasks = tasks;
  },

  addTask: (state, task) => {
    state.tasks.push(task);
  },

  addTasks: (state, tasks) => {
    tasks.forEach(task => {
      state.tasks.push(task);
    });
  },

  setCurrentTask: (state, task) => {
    state.currentTask = task;
  },

  setTasksDate: (state, tasks) => {
    state.tasksDate = tasks;
  },

  addTaskDate: (state, task) => {
    state.tasksDate.push(task);
  },

  setOrdersList: (state, orders) => {
    state.ordersList = orders;
  },

  setEmployeesList: (state, employees) => {
    state.employeesList = employees;
  },

  setServicesList: (state, services) => {
    state.servicesList = services;
  },

  setReasonsList: (state, reasons) => {
    state.reasonsList = reasons;
  },

  setReiterationsList: (state, reiterations) => {
    state.reiterationsList = reiterations;
  },

  setTaskStatuses: (state, statuses) => {
    state.taskStatuses = statuses;
  },

  setDay: (state, day) => {
    state.day = day;
  },

  setOrder: (state, order) => {
    state.order = order;
  },

  setSelectedDay: (state, day) => {
    state.selectedDay = day;
  },

  setSelectedEntity: (state, entity) => {
    state.selectedEntity = entity;
  },

  setScheduleFilters: (state, filters) => {
    state.filters = filters;
  },

  updateTask: (state, task) => {
    state.tasks = state.tasks.map(item => {
      if (item.id === task.id) {
        return Object.assign({}, item, task);
      }

      return item;
    });
  },

  updateTaskDate: (state, task) => {
    state.tasksDate = state.tasksDate.map(item => {
      if (item.id === task.id) {
        return Object.assign({}, item, task);
      }

      return item;
    });
  },

  removeTask: (state, taskId) => {
    state.tasks = state.tasks.filter(i => i.id !== taskId);
  },

  removeTasks: (state, taskIds) => {
    state.tasks = state.tasks.filter(i => !taskIds.includes(i.id));
  },

  removeTaskDate: (state, taskId) => {
    state.tasksDate = state.tasksDate.filter(i => i.id !== taskId);
  },

  addSnacks: (state, snack) => {
    state.snacks.push(snack);
  },

  setSnacks: (state, snacks) => {
    state.snacks = snacks;
  },

  clearSnacks: state => {
    state.snacks = [];
  },

  setIsMultiTaskUpdate: state => {
    state.isMultiTaskUpdate = !state.isMultiTaskUpdate;
  },

  setEmployeesRequestedVacations: (state, arr) => {
    state.employeesRequestedVacations = arr;
  },

  clearEmployeesRequestedVacations: state => {
    state.employeesRequestedVacations = [];
  }
};
